export { NotificationProvider, useNotification } from './provider';
export { ToastNotification } from './toast';
export { ModalNotification } from './modal';
export { RetryToastBridge } from './retry-toast-bridge';

export type {
	NotificationType,
	NotificationVariant,
	NotificationOptions,
	NotificationAction,
	NotificationItem,
} from '@/utils/notification-manager';

export {
	determineNotificationType,
	determineNotificationVariant,
	convertAlertButtonsToActions,
	generateNotificationId,
	getPlatformDefaults,
	notificationQueue,
} from '@/utils/notification-manager';
